"use client";

import { useContext } from "react";
import { AuthContext, enhanceUserData } from "@jetblue/dotcom-auth/legacy";

import {
  Authenticated,
  type AuthenticatedProperties,
} from "./true-blue/authenticated";
import {
  Unauthenticated,
  type UnauthenticatedProperties,
} from "./true-blue/unauthenticated";

export type HeaderTrueBlueProperties = {
  creditProfileMenu: AuthenticatedProperties["creditProfileMenu"];
  loggedInMenu: AuthenticatedProperties["loggedInMenu"];
  loggedOutMenu: UnauthenticatedProperties;
  useAuth?: boolean;
};
export const HeaderTrueBlue = ({
  creditProfileMenu,
  loggedInMenu,
  loggedOutMenu,
  useAuth,
}: HeaderTrueBlueProperties) => {
  const hasAuthToken = useContext(AuthContext).IS_TOKEN_STORED?.stored;
  const customerDetails = useContext(AuthContext).PROFILE?.customerDetails;
  const isCreditProfile = useContext(AuthContext).IS_CREDIT_PROFILE_USER;
  const isSignedIn = useAuth && hasAuthToken && customerDetails;

  return isSignedIn ? (
    <Authenticated
      creditProfileMenu={creditProfileMenu}
      customerDetails={enhanceUserData({ customerDetails, isCreditProfile })}
      loggedInMenu={loggedInMenu}
    />
  ) : (
    <Unauthenticated {...loggedOutMenu} />
  );
};

HeaderTrueBlue.displayName = "Header.TrueBlue";
